export class IShippingClassHeaderItem {
    region: string;
    region_code: string;
}
